import { render } from "./User_Checkout.vue?vue&type=template&id=27d917a0&scoped=true"
import script from "./User_Checkout.vue?vue&type=script&lang=js"
export * from "./User_Checkout.vue?vue&type=script&lang=js"

import "./User_Checkout.vue?vue&type=style&index=0&id=27d917a0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Mizu\\Desktop\\hexschool-Vue-week8 - 提交修改完成\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d917a0"]])

export default __exports__